/* eslint-disable */
import P from 'prop-types';
import { ButtonMenu } from './styles';
export default function MenuItem({ count, name, onClick, className, status, index }) {
  return (
    <div>
      <ButtonMenu className={`${className} ${status == index && 'active'}`} variant="contained" onClick={onClick}>
        {name} <span className="count">{count}</span>
      </ButtonMenu>
    </div>
  );
}

MenuItem.propTypes = {
  onClick: P.func,
  name: P.string.isRequired,
  count: P.any,
  className: P.string.isRequired,
  status: P.number,
  index: P.number,
};

MenuItem.defaultProps = {
  onClick: () => {},
  count: 0,
};
